import React from "react";
import BlogTemplate from "./BlogTemplate"; // Adjust path if necessary

// Import your images here (update paths to match your actual files)
import PropagationHeroImage from "../../assets/images/Blogs/Thumbnails/security-propagation.jpg";
import ConditionImage from "../../assets/images/Blogs/SecurityPropagation/condition.png";
import DefineBMIDEImage from "../../assets/images/Blogs/SecurityPropagation/define_bmide.png";

const SecurityPropagation = () => {
  return (
    <BlogTemplate
      bannerTitle="Auto Propagation of Property Values in Teamcenter 11.2.x"
    >
      {/* Introduction Section */}
      <section className="container content-container">
        <div className="text-container">
          <p>
            Teamcenter 11.2.x supports auto propagation of property values from one object to another objects using relationship, references and non-workspace objects on specific action in certain condition.
          </p>
          <p>
            It‘s a very common business scenario where you need to copy property values from one object to another objects say Item to Item Revisions to datasets/forms and so on, also from item to item revision to other item revisions which is associated with different relations for security controls like ADA/Projects/Security Classificaiton and also for other busines purposes. 
          </p>
          <p>
            In older Teamcenter releases, addressing this requirement relied on a functionaility through preferences where you can propgate value from Item to Item Revsion to dataset but not to the other associated objects. For that you have to write your own customization or define a process where user has to classify each object manually which is really a cumbersome and prone to human errors.
          </p>
          <p>
            To address above business needs, Teamcenter 11.2.x introduces BMIDE based Propgation Rules which help write propagation rules for multi-level data structure, in reverse as well as forward direction, on several types of action/opeartion (check-in, save, revise, export, delete etc) with condition control on when propgation should happen and also on which objects should be traversed. 
          </p>
          <p>
            Importantly, it provides OOTB security propagation styles such as merge, fill in, override and order of precedance which offers a great flexibity to propgate property values from one object to another object while addressing varied busienss requirements.
          </p>
        </div>
        <div className="image-container" style={{ margin: "2rem auto", width: "100%" }}>
           <img src={PropagationHeroImage} alt="Add Propagation Rule UI in Teamcenter" />
        </div>
      </section>

      {/* Key Features Section */}
      <section className="blog-section" style={{ backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
        <h2 className="sub-title">Key Features of BMIDE Propagation Rules</h2>
        
        <h3 className="key-element-title">Propagation Types</h3>
        <ul className="blog-list">
          <li><strong>Through Relations & References:</strong> Propagation through relation (IMAN_SPECIFICATION, DIRECT MODEL, ANY), reference (rev_list), and non-workspace objects.</li>
          <li><strong>Multilevel Propagation:</strong> You can define propagation which will traverse several levels of objects, such as a multilevel item data structure.</li>
          <li><strong>Forward Propagation:</strong> You can define property on item revision (primary object) and that can get propagated to datasets/forms/other objects (secondary objects) associated there.</li>
          <li><strong>Reverse Propagation:</strong> You can define property on dataset/forms (secondary object) and that can get propagated to item revision (primary objects) associated there.</li>
        </ul>

        <h3 className="key-element-title" style={{ marginTop: "2rem" }}>Conditional Control</h3>
        <ul className="blog-list">
          <li><strong>Action Conditions:</strong> Support controlling propagation action based on condition where you can right any required condition to evaluate before actual propagation to happen. For example, propagating the "IP Classification" property from Item to Item Revision only when IP Classification is set to "Super Secret".</li>
          <li><strong>Traversal Conditions:</strong> Support controlling traversal of objects for propagation based on condition where you can right condition to control traversal to business objects. For example, propagating property values excluding Item Revisions having the name "Prototype".</li>
        </ul>
        <div className="image-container" style={{ margin: "1.5rem auto", width: "100%", maxWidth: "700px" }}>
           <img src={ConditionImage} alt="BMIDE condition signature evaluation for propagation" />
        </div>
      </section>

      {/* How to Define Section */}
      <section className="blog-section">
        <h2 className="sub-title">How to define Propagation Rules in BMIDE?</h2>
        <ol className="blog-list" style={{ listStyleType: "decimal", paddingLeft: "20px" }}>
          <li>Identify the property and define the required security group using property constant.</li>
          <li>Launch propagation rule editor through RMB on project.</li>
          <li>Click on Add new Rule and Define Various Parameters Based on your propagation requirements.</li>
          <li>Deploy the BMIDE template.</li>
          <li>Generate the report for specific security group to get info on what are all those properties the specific group is associated and also what are all rules using that group is present in the system.</li>
        </ol>
        <div className="image-container" style={{ margin: "2rem auto", width: "100%", maxWidth: "800px" }}>
           <img src={DefineBMIDEImage} alt="Property constants and BMIDE propagation rule configuration" />
        </div>
      </section>

      {/* Business Scenarios Section */}
      <section className="blog-section" style={{ backgroundColor: "#f0f8ff", borderRadius: "8px" }}>
        <h2 className="sub-title">Common Business Scenarios</h2>
        
        <h3 className="key-element-title">Propagate Security Attributes</h3>
        <p>
          Propagate Security Projects, Classification (GOV/IP) and ITAR/IP licenses to control security on business objects, this is very common scenario where you want these attributes to be populated on several destination objects from the source object. Actually you set these attributes on source object and want these attributes on all other objects should get values populated automatically. Examples include:
        </p>
        <ul className="blog-list">
          <li>Propagate project security (Project_List, Owning _Project) to entire Item Structure on specific action say save action on source object.</li>
          <li>Propagate IP/GOV classification to all the objects within item data structure.</li>
          <li>Propagate IP/ITAR license to all the objects within item structure and this should happen when item as classified as "super-secret" and not for other cases.</li>
        </ul>

        <h3 className="key-element-title" style={{ marginTop: "2rem" }}>Propagate Non-Security Attributes</h3>
        <p>
          This could be any property on business object which you need to propagate from one object to another object but not for the purpose of access control. This situation is also common where you want value to be same for all the associated objects as the source object. Example: Propagate custom property "usage type" from item to item revisions provided item has IP_Classification set to "Proprietary" and only to those item revisions where object_name is not prototype.
        </p>
      </section>

      {/* Upgrade & Benefits Section */}
      <section className="blog-section">
        <h2 className="sub-title">Upgrading to TC 11.2.x? Important Steps</h2>
        <p className="text-bold">
          Don’t forget to perform the below steps when you are upgrading from older releases to TC11.2.x. This is required to convert your old preference propagation rules to BMIDE based propagation rules. If you don’t do perform below steps existing propagation you have defined in your system will not work.
        </p>
        <ul className="blog-list">
          <li>Upgrade process will create <code>propagation_preference_rules.xml</code> file automatically in <code>TC_DATA\model</code> directory, which you have to import in BMIDE project and deploy it.</li>
          <li>This will ensure that required propagation rule get created for the preferences you had in older release.</li>
        </ul>

        <h3 className="key-element-title" style={{ marginTop: "2rem" }}>Benefits of Propagation Rules</h3>
        <ul className="blog-list">
          <li>Consistent and easy way to manage propagation rules using BMIDE.</li>
          <li>Flexibility in propagating property values from one object to another objects.</li>
          <li>Condition can be used to control propagation action and traversal for propagation.</li>
          <li>Easy way to achieve multi-level propagation and propagation in forward and reverse direction.</li>
          <li>Configure propagation for any types of objects association such as reference, relation, non-workspace object.</li>
          <li>Ideally I see no limit for traversing objects level for propagation.</li>
        </ul>
      </section>
    </BlogTemplate>
  );
};

export default SecurityPropagation;
